import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";

export const stopsType = blocksOptionsConfig.collectionTypes.stops.value;

export const stopsConfig = newCollectionTemplate({
  typeFields: {
    stopId: "number",
    stopName: "text",
    isShow: "boolean",
  },
  itemTemplate: {
    stopId: "",
    stopName: "",
    isShow: true,
  },
  type: stopsType,
  showAsTitle: "stopName", // only texts fields
  allowUseSets: false,
});

// export const stopsConfig1 = {
//   typeFields: {
//     stopId: "number",
//     stopName: "text",
//   },
//   itemTemplate: {
//     stopId: "",
//     stopName: "",
//   },
//   type: stopsType,
//   showAsTitle: "stopName", // only texts fields
//   allowUseSets: false,
// };

export const initBlockData = {
  title: "Main stops",
  collections: {
    [stopsType]: {
      ...stopsConfig,
      items: [],
    },
  },
};

export const initEmptyBlockData = {
  title: "",
  collections: {
    [stopsType]: {
      ...stopsConfig,
      items: [],
    },
  },
};
